import type { Database } from '../database.types';
import { getSupabaseClient, type DdmSupabaseClient } from '../supabase';

export type UserProfile = Database['public']['Tables']['users']['Row'];

export async function getProfile(
  userId: string,
  client: DdmSupabaseClient = getSupabaseClient(),
): Promise<UserProfile | null> {
  const { data, error } = await client.from('users').select('*').eq('id', userId).maybeSingle();
  if (error) throw error;
  return data;
}
